<template>
	<div class="wrap">
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>党员管理</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="dydetail">
						<div class="dyimg">
							<img src="@/assets/images/adminMan.png" v-if="u_pic==null||u_pic==''||u_pic.search('http') == -1">
							<img :src="u_pic" v-else>
						</div>
						<el-descriptions class="margin-top" :title="u_name" :column="3" >
							<template slot="extra">
								<el-button type="primary" size="small" @click="edit()">编辑</el-button>
								<el-button type="primary" size="small" @click="$router.go(-1)">返回上级</el-button>
							</template>
							<el-descriptions-item v-for="(item,index) in detailList">
								{{item.name}} : 
								{{item.value}}
							</el-descriptions-item>
						</el-descriptions>
					</div>
					<el-steps :active="zhiwu==6?zhiwu+1:zhiwu-1" :simple="true" finish-status="success"  style="margin-top: 20px">
						<el-step title="入党申请" ></el-step>
						<el-step title="积极分子" ></el-step>
						<el-step title="发展对象" ></el-step>
						<el-step title="预备党员" ></el-step>
						<el-step title="转正考察" ></el-step>
						<el-step title="已转正" ></el-step>
					</el-steps>
					<div class="step_box">
						<Steps :step="step" @dataList="dataList" :file="file"></Steps>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { dygl } from '@/axios'
	import { Message } from 'element-ui'
	import Steps from './components/stepList.vue'
	export default{
		data(){
			return{
				getdata:{
					user_id:this.$store.state.user.userinfo.id,
					flag:this.$store.state.user.userinfo.flag,
					dw_name:this.$store.state.user.userinfo.dw_name,
					organ_class:"",
					sign:2
				},
				step:"",//发展阶段
				u_name:"",
				u_pic:'',
				detailList:[
					{
						name:"性别",
						value:"-",
						key:'sex',
						icon:"el-icon-user-solid"
					},
					{
						name:"党员身份",
						key: 'u_zhiwu',
						value:"-",
						icon:"el-icon-s-custom"
					},
					{
						name:"民族",
						value:"-",
						key: 'nation_name',
						icon:"el-icon-s-check"
					},
					{
						name:"申请入党时间",
						value:"-",
						key:'applytime',
						icon:"el-icon-phone"
					},
					{
						name:"学历",
						key:'education_name',
						key:'',
						icon:"el-icon-s-cooperation"
					},
					{
						name:"出生日期",
						value:"-",
						key:'age',
						icon:"el-icon-suitcase"
					},
					{
						name:"累计党组织活动(次)",
						value:"-",
						key:'activity_count',
						icon:"el-icon-location"
					},
					{
						name:"联系电话",
						key:'u_phone',
						value:"-",
						icon:"el-icon-user-solid"
					},
					{
						name:"身份证号",
						key:'card',
						value:"-",
						icon:"el-icon-user-solid"
					},
					{
						name:"通讯地址",
						key:'postal_address',
						value:"-",
						icon:"el-icon-user-solid"
					},
					{
						name:"所属单位",
						key:'company',
						value:"-",
						icon:"el-icon-s-data"
					}
				],
				zhiwu:1,
				file:{}
			}
		},
		components:{Steps},
		methods:{
			// 关闭弹窗
			closeEdit(){
				var that = this;
				that.dialogVisible = false;
				that.dataList();
			},
			// 编辑
			edit(data){
				var that = this;
				that.$router.push({
					path:'/dyxx_add',
					query:{
						type:'edit',
						uid:that.$route.query.uid,
						cy_zz:that.$route.query.cy_zz,
						id:that.$route.query.id,
					},
				})
			},
			// 获取数据
			dataList(){
				var that = this;
				dygl.updateMemberBind({
					id:that.$route.query.id
				}).then(res => {
					if(res.code == 200){
						that.u_name = res.data.u_name;
						that.u_pic = res.data.u_picture;
						for(let key in res.data){
							that.detailList.forEach((ele, label) => {
								if(ele.key === 'u_zhiwu'){
									ele.value = that.$changeZhiwu(res.data.u_zhiwu)
								}else{
									if(key === ele.key){
										ele.value = res.data[key] ? res.data[key] : '-'
									}
								}
							});
						}
						that.step = res.data.u_zhiwu_status;
						that.zhiwu = that.$changeDev(that.step);
						if(res.data.file){
							that.file = res.data.file;
						}else{
							that.file = {}
						}
					}
				})
			},
		},
		mounted() {
			var that = this;
			that.dataList();
			that.$emit('selectTop',4);
		},
		created() {
			var that = this;
			that.$emit('selectTop',4)
		}
	}
</script>

<style lang="scss">
	.el-descriptions__title{
		display: flex;
		font-size: 20px;
		align-items: center;
	}
	.el-descriptions-item__label.has-colon::after{
		content: "" !important;
	}
	.dydetail{
		width: 100%;
		display: flex;
		.dyimg{
			width: 160px;
			height: 200px;
			background: #DDDDDD;
			margin-right: 20px;
			border-radius: 10px;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
	.el-descriptions{
		flex: 1;
	}
	.subtitle{
		width: 100%;
		height: 50px;
		border: 1px solid #DDDDDD;
		line-height: 50px;
		border-left: none;
		margin: 20px 0;
		color: #333;
		font-size: 14px;
		border-right: none;
		>span{
			display: inline-block;
			height: 100%;
			cursor: pointer;
			border-bottom: 2px solid rgba($color: #000000, $alpha: 0);
			padding: 0 20px;
		}
		>span:hover{
			color: #000000;
			border-bottom: 2px solid #bb0000;
		}
		.selectBar{
			color: #000000;
			border-bottom: 2px solid #bb0000;
		}
	}
	.step_box{
		width: 100%;
	}
	.el-step__title.is-process{
		color: #1266E3 !important;
	}
	.el-step__head.is-process{
		color: #1266E3 !important;
		border-color: #1266E3 !important;
	}
	.el-step__title.is-process{
		color: #1266E3 !important;
	}
</style>

